<div 
  class="expand-icon-container" 
  (click)="onExpandClick($event)"
  [class.expanded]="isToggleExpanded"
>
  <i 
    class="fas"
    [class.fa-chevron-right]="!isToggleExpanded"
    [class.fa-chevron-down]="isToggleExpanded"
  ></i>
</div>